export const generateFieldComponentId = (
  fid: string,
  fieldIndex: number = 1,
) => {
  return `${fid}-${fieldIndex}`
}
